import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { useRef } from 'react';
import { useModifiedPopper } from '../../hooks/useModifiedPopper';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import { useOnOff } from '../../hooks/useOnOff';
import { Portal } from '../../root-layout/Portal';
import FixedColorPreview from '../preview/FixedColorPreview';
import { ColorPicker } from '../react-color/ColorPicker';
import * as colorHelper from '../react-color/helpers/color';
const ColorPickerRoot = styled.button `
  position: relative;
  width: 100%;
  border: 1px solid darkgray;
  border-radius: 0.25rem;
  height: 30px;
  padding: 5px;
`;
const ColorPickerPreview = styled.div `
  height: 100%;
  width: 100%;
  border-radius: 0.125rem;
`;
export function ColorPickerDropdown(props) {
    const { color, ...otherProps } = props;
    const ref = useRef(null);
    const [isOpened, , close, toggle] = useOnOff(false);
    const { hex } = colorHelper.toState(color || 'white');
    const { setReferenceElement, setPopperElement, popperProps } = useModifiedPopper({
        placement: 'bottom-start',
        offset: 6,
    });
    useOnClickOutside(ref, close);
    return (_jsxs(_Fragment, { children: [_jsx(ColorPickerRoot, { type: "button", ref: setReferenceElement, onClick: toggle, children: _jsx(ColorPickerPreview, { children: _jsx(FixedColorPreview, { color: hex }) }) }), isOpened && (_jsx(Portal, { children: _jsx("div", { ref: (div) => {
                        setPopperElement(div);
                        ref.current = div;
                    }, ...popperProps, children: _jsx(ColorPicker, { color: color, ...otherProps }) }) }))] }));
}
//# sourceMappingURL=ColorPickerDropdown.js.map